import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "-mx-6 w-[calc(100%+48px)]" }
const _hoisted_2 = { class: "fixed top-20 left-0 z-10 bg-white px-6 py-4 shadow-[0_1px_0px_0px_rgba(0,0,0,0.08)] flex justify-between items-center w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Back", -1)
const _hoisted_4 = { class: "mt-20 mb-6 mx-6" }
const _hoisted_5 = { class: "max-w-[500px] mx-auto py-6" }
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = { class: "w-full flex items-center justify-end space-x-3" }

import { ref } from "vue";
import InformationFormSection from "./Informations/FormSection.vue";
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { useRouter } from "vue-router";
import TeleCpuLocationService from "@/classes/Settings/TeleCpuLocationService";
import { errorResponse } from "@/helpers/errorMessage";
import ArrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const router = useRouter();

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const successMessage = ref<string>("Data has been successfully saved!");
const form = ref<{ name: string }>({
	name: "",
});
const errors = ref<any>();

const save = (): void => {
	TeleCpuLocationService.store(form.value)
		.then((response: any) => {
			showConfirmation.value = true;
			successMessage.value = response.data.message;
		})
		.catch((error: any) => (errors.value = errorResponse(error.response?.data?.errors)));
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
	router.replace("/settings/telecpu-locations/index");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings/telecpu-locations/index')))
          }, [
            _createVNode(ButtonComponent, { customClass: "tertiary text-black hover:text-primary-600 transition" }, {
              default: _withCtx(() => [
                _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
                _hoisted_3
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(InformationFormSection, {
              form: form.value,
              errors: errors.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).replace(`/settings/telecpu-locations/index`)))
                    }, [
                      _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Cancel")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(ButtonComponent, {
                      btnWidth: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (save()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Save Changes")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(ConfirmationModal, {
                    typeTwo: true,
                    show: showConfirmation.value,
                    onCancel: _cache[3] || (_cache[3] = ($event: any) => (showConfirmation.value = false)),
                    onConfirm: _cache[4] || (_cache[4] = ($event: any) => {
									showSuccess.value = true;
									showConfirmation.value = false;
								}),
                    "cancel-text": "Cancel",
                    "action-text": "Confirm",
                    title: "Save Record",
                    content: "Are you sure you wish to save this record?"
                  }, null, 8, ["show"]),
                  _createVNode(SuccessModal, {
                    show: showSuccess.value,
                    onConfirm: _cache[5] || (_cache[5] = ($event: any) => (redirectSuccess())),
                    "action-text": "Close",
                    title: "Record Saved!",
                    content: successMessage.value
                  }, null, 8, ["show", "content"])
                ])
              ]),
              _: 1
            }, 8, ["form", "errors"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})